import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchivePagesLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivePagesLoader" */ '../src/ArchivePagesLoader'
			)
		).ArchivePagesLoader,
});
